/* unplugin-vue-components disabled */import { render } from "./IFooter.vue?vue&type=template&id=db4f75c2&scoped=true"
import script from "./IFooter.vue?vue&type=script&lang=js"
export * from "./IFooter.vue?vue&type=script&lang=js"

import "./IFooter.vue?vue&type=style&index=0&id=db4f75c2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db4f75c2"]])

export default __exports__